module.exports = __webpack_public_path__ + "static/img/jumper_red.50ef4519.png";